module.exports = __webpack_public_path__ + "img/18600.2c743822.jpg";